<template>
  <div>
    <div class="page-title">Edit Chat Box</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Chatbox"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.chats.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.Chat.update(this.form);
      this.$router.push("/chats");
    },
    async setForm() {
      const { data } = await this.$api.Chat.get({ id: this.$route.params.id });
      this.form = data;
    },
  },
};
</script>

<style></style>
